export default "__VITE_ASSET__C0bAZI4R__"